import { compareDesc, differenceInCalendarDays } from "date-fns";
import { createSelector } from "reselect";

import { SubscriptionPhase } from "constants/subscription-phase";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { getSubscriptionPhase, inTrial } from "helpers/subscription";
import { IStoreState } from "interfaces/storeState";
import { createRequestFetchingSelector } from "store/requests/selectors";

import { IWithBillingEntitiesState, getBilling } from "../billing";
import { IEntityCollectionState } from "../reducer";

import { SubscriptionActionsNames } from "./actions";
import { ISubscription } from "./interfaces";

export interface IWithSubscriptionsState {
  entities: {
    subscriptions: IEntityCollectionState<ISubscription>;
  };
}

function sortByExpirationDate(a: ISubscription, b: ISubscription): number {
  return compareDesc(a.subscriptionExpiresAt, b.subscriptionExpiresAt);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectCurrentSubscription = (state: IWithSubscriptionsState) =>
  Object.values(state.entities.subscriptions).sort(sortByExpirationDate)[0] || null;

export const getCurrentSubscriptionDaysLeft = (state: IWithSubscriptionsState): number => {
  const subscription = selectCurrentSubscription(state);
  const today = new Date();

  return subscription ? differenceInCalendarDays(subscription.currentPeriodEndsAt, today) : 0;
};

export const selectSubscriptionPhase = (
  state: IWithSubscriptionsState & IWithBillingEntitiesState
): SubscriptionPhase => {
  const subscription = selectCurrentSubscription(state);
  const billing = getBilling(state);

  return getSubscriptionPhase(subscription, billing);
};

export const selectIsTrial = (state: IWithSubscriptionsState): boolean => {
  const subscription = selectCurrentSubscription(state);
  return inTrial(subscription);
};

export const selectCurrentSubscriptionPlan = createSelector(
  [selectCurrentSubscription],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currentSubscription: any) => currentSubscription.plan
);

export const selectSeatsCount = createSelector(
  [selectCurrentSubscription],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currentSubscription: any) => currentSubscription.agents
);

export const selectIsSubscriptionCanceled = createSelector(
  [selectCurrentSubscription],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currentSubscription: any) => currentSubscription.isCanceled
);

export const selectIsAddingSubscription = (state: IStoreState): boolean =>
  createRequestFetchingSelector([SubscriptionActionsNames.CREATE])(state);

export const selectIsUpdatingSubscription = (state: IStoreState): boolean =>
  createRequestFetchingSelector([SubscriptionActionsNames.UPDATE])(state);

export const selectIsCancelingSubscription = (state: IStoreState): boolean =>
  createRequestFetchingSelector([SubscriptionActionsNames.DELETE])(state);
